import axios from 'axios';

export default {
  fetchAdjustmentReasons(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventory-adjustments/reasons", {params})
      .then(results=>{
        return results.data;
      })
  },
  fetchAdjustment(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventory-adjustments", {params})
      .then(results=>{
        return results.data;
      })
  },
  postAdjustment(adjustment){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventory-adjustments", adjustment)
      .then(results=>{
        return results.data;
      })
  },
  deleteAdjustment(adjId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventory-adjustments/"+adjId);
  },
  deleteAdjustmentItem(adjId, adjItemId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/inventory-adjustments/"+adjId+"/"+adjItemId);
  }
}
